import React from 'react';
import PropTypes from 'prop-types';

import generalContent from 'assets/content/general.content.json';

import style from './StorageOptionsMobieView.module.scss';

StorageOptionsMobieView.propTypes = {
    onClick: PropTypes.func.isRequired,
    selectedStorage: PropTypes.object,
    options: PropTypes.array,
    editSpecification: PropTypes.bool,
    productSlug: PropTypes.string,
    isProductDA: PropTypes.bool
};

function StorageOptionsMobieView({
    onClick,
    selectedStorage,
    editSpecification,
    options,
    productSlug,
    isProductDA = false
}) {
    const getStorageClassname = (option) => {
        const classname = (selectedStorage.value === option?.id || selectedStorage.value === option?.value || selectedStorage.value === option?.label) ? style.option + ' ' + style.option__selected : style.option;

        if (option?.label === '256GB' && productSlug === 'samsung-galaxy-s25-edge') {
            return classname + ' ' + style.option__disablebutton;
        }

        if (productSlug === 'samsung-galaxy-s25-edge') {
            return classname + ' ' + style.option__freeupgrade;
        }

        return classname;
    };

    const isPASlimProduct = productSlug === 'samsung-galaxy-s25-edge';

    return (
        <div className={`${style.StorageOptionsWrapper}`}>
            <div className={style.StorageOptionsWrapper__label}>{isProductDA ? generalContent.SAMSUNG_SC : generalContent?.STORAGE}</div>
            <div className='width-100 d-block'>
                {
                    isPASlimProduct &&
                    <div className={style.option__freeupgradeheader}>
                        <span>Pre-order promo: </span>
                        <strong>Complimentary Storage Upgrade</strong>
                        <span> worth S$180 </span>
                    </div>
                }
                <div className={style.StorageOptionsWrapper__options}>
                    {options && options.map((option, i) =>
                        <div
                            key={i}
                            className={getStorageClassname(option)}
                            onClick={() => onClick(option)}>
                            {option.label === '512GB' && isPASlimProduct &&
                                <div className={style.option__freeupgradebuttontext}>
                                    <span>Free upgrade</span>
                                </div>
                            }
                            <div className={(selectedStorage.value === option?.id || selectedStorage.value === option?.value || selectedStorage.value === option?.label) ? style.option__title + ' ' + style.option__title__selected : style.option__title}>
                                <span className={style.option__title__color__selection__image__span}>{option.label}</span>
                            </div>
                            <div className={!option?.is_out_of_stock ? style.StorageOptionsWrapper__stock_status : style.StorageOptionsWrapper__out_stock_status}>
                                {(option.is_out_of_stock) && 'Out of stock'}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>);
}

export default StorageOptionsMobieView;
